import { isWeekend } from "date-fns";

export const getRowColor = publicHolidayDates => (
  item: Object,
  rowIndex: number,
  getClassName?: boolean,
) => {
  if (!item.recordedDay) {
    return "";
  }

  if (isWeekend(new Date(item.recordedDay))) {
    return "background-color-weekend";
  }

  const date: ?string = new Date(item.recordedDay).toISOString().substring(0, 10);
  const isHoliday: boolean = publicHolidayDates.indexOf(date) !== -1;
  if (isHoliday) {
    return "background-color-holiday";
  }

  return "";
};
